// import img from '/Image/female 1.png'
export const data = [
  {
    id: 1,
    name: "Britte",
    email: "bgobourn0@usatoday.com",
    gender: "Female",
    hair9_color: "Black",
    language: "Kannada",
    img: "./Image/female 1.png",
  },
  {
    id: 2,
    name: "Bucky",
    email: "btabram1@va.gov",
    gender: "Male",
    hair9_color: "White",
    language: "Hindi",
    img: "/Image/male 1.png",
  },
  {
    id: 3,
    name: "Shaughn",
    email: "stwede2@stanford.edu",
    gender: "Female",
    hair9_color: "Red",
    language: "English",
    img: "/Image/female 3.png",
  },
  {
    id: 4,
    name: "Twyla",
    email: "tsimpkin3@t.co",
    gender: "Female",
    hair9_color: "Black",
    language: "Kannada",
    img: "/Image/female 4.png",
  },
  {
    id: 5,
    name: "Ilse",
    email: "ipartner4@fotki.com",
    gender: "Female",
    hair9_color: "White",
    language: "Hindi",
    img: "./Image/female 2.png",
  },
  {
    id: 6,
    name: "Tonie",
    email: "ttwydell5@wordpress.com",
    gender: "Female",
    hair9_color: "Red",
    language: "English",
    img: "./Image/female 5.png",
  },
  {
    id: 7,
    name: "Addia",
    email: "adykas6@blog.com",
    gender: "Female",
    hair9_color: "Black",
    language: "Kannada",
    img: "./Image/female 6.png",
  },
  {
    id: 8,
    name: "Linet",
    email: "lsommerling7@abc.net.au",
    gender: "Male",
    hair9_color: "White",
    language: "Hondi",
    img: "./Image/male 3.png",
  },
  {
    id: 9,
    name: "Irwin",
    email: "imaciaszek8@plala.or.jp",
    gender: "Male",
    hair9_color: "Red",
    language: "English",
    img: "./Image/male 4.png",
  },
  {
    id: 10,
    name: "Berti",
    email: "bbeuscher9@facebook.com",
    gender: "Male",
    hair9_color: "Black",
    language: "Kannada",
    img: "./Image/male 8.png",
  },
  {
    id: 11,
    name: "Zebadiah",
    email: "zkohena@oracle.com",
    gender: "Male",
    hair9_color: "White",
    language: "Hindi",
    img: "./Image/male 6.png",
  },
  {
    id: 12,
    name: "Allie",
    email: "afleischmannb@skype.com",
    gender: "Male",
    hair9_color: "Red",
    language: "English",
    img: "./Image/male 7.png",
  },
  {
    id: 13,
    name: "Arman",
    email: "amatusc@microsoft.com",
    gender: "Male",
    hair9_color: "Black",
    language: "Kannada",
    img: "/Image/male 9.png",
  },
  {
    id: 14,
    name: "Troy",
    email: "tabeled@reference.com",
    gender: "Female",
    hair9_color: "White",
    language: "English",
    img: "./Image/female 7.png",
  },
  {
    id: 15,
    name: "Nichol",
    email: "nlowndse@last.fm",
    gender: "Female",
    hair9_color: "Red",
    language: "Kannada",
    img: "./Image/female 8.png",
  },
  {
    id: 16,
    name: "Jaquelyn",
    email: "jvanhalenf@tinypic.com",
    gender: "Female",
    hair9_color: "Black",
    language: "Hindi",
    img: "./Image/female 9.png",
  },
  {
    id: 17,
    name: "Caty",
    email: "cdriscollg@reddit.com",
    gender: "Female",
    hair9_color: "White",
    language: "English",
    img: "./Image/female 10.png",
  },
  {
    id: 18,
    name: "Milt",
    email: "mbenaharonh@java.com",
    gender: "Male",
    hair9_color: "Red",
    language: "Kannada",
    img: "./Image/male 1.png",
  },
  {
    id: 19,
    name: "Gaylene",
    email: "gmacswaydei@techcrunch.com",
    gender: "Female",
    hair9_color: "Black",
    language: "Hindi",
    img: "./Image/female 11.png",
  },
  {
    id: 20,
    name: "Pace",
    email: "peppersonj@topsy.com",
    gender: "Male",
    hair9_color: "White",
    language: "English",
    img: "./Image/male 3.png",
  },
  {
    id: 20,
    name: "Pace",
    email: "peppersonj@topsy.com",
    gender: "Male",
    hair9_color: "White",
    language: "English",
    img: "./Image/male 3.png",
  },
];
export default data;
